import { useRef, useState } from "react"
import { TRANS_SS_MODES } from "../../../helpers"

export class DeviceBoxManagement {


    updateSsMode(targetMode) {
        const promise = this._onStateChange(this._deviceName, 'SET_MODE', targetMode)
        promise.then(() => {
            this._setMode(targetMode)
        }).catch()
    }

    isActive() {
        return this._mode !== 'frostprotection'
    }

    generateSelectOptions() {
        return Object.keys(TRANS_SS_MODES).map((key) => {
            return <option value={key} key={key}>{TRANS_SS_MODES[key]}</option>
        })
    }

    switchState() {
        if (this.isActive()) {
            this.updateSsMode('frostprotection')
        } else {
            this.updateSsMode('comfort')
        }
    }
}

export default function HousePilotDeviceBoxSS({ deviceName, deviceLabel, mode, onStateChange }) {

    const [smode, setMode] = useState(mode)

    const manager = new DeviceBoxManagement()
    manager._onStateChange = onStateChange
    manager._deviceName = deviceName
    manager._mode = mode
    manager._setMode = setMode


    return (
        <>
            <div className={"m-1 col-6 col-md-6 col-lg-3 deviceBox " + (manager.isActive() ? 'active' : '')}>
                <h6>{deviceLabel}
                    <i className="fa fa-power-off btn-power-switch float-center" onClick={() => { manager.switchState() }}></i></h6>
                <i className="fa fa-temperature-1"></i> <select className="d-inline-block w-90 form-control mt-2" value={manager._mode} onChange={(e) => { manager.updateSsMode(e.target.value) }}>
                    {manager.generateSelectOptions()}
                </select><br />

            </div>


        </>
    )
}
